import React, { useState } from "react";
import homeStyle from "./styles";
import { Avatar, Box, Typography, Button } from "@mui/material";
import SongDetails from "../SongDetail/SongDetails";
import ReturnCalculator from "../RetrunCalculator/index";
import Popup from "../Popup";
import { enquireNowGTMCTAClick } from "../../util/gtmutil";
import auth from "../Layout/util/auth";

const HowItWorks = (data) => {
  console.log("calculator conditon", data);
  const { songPage = false, tierData = [], version = false } = data;
  const r = auth();

  const hiw_title1 = data?.data?.get("hiw_title1");
  const hiw_desc1 = data?.data?.get("hiw_desc1");
  const hiw_title2 = data?.data?.get("hiw_title2");
  const hiw_desc2 = data?.data?.get("hiw_desc2");
  const hiw_title3 = data?.data?.get("hiw_title3");
  const hiw_desc3 = data?.data?.get("hiw_desc3");
  const [calculator, setCalculator] = useState(false);
  console.log("calculator value", calculator);
  const howitworksheading = data?.data?.get("howitworksheading");
  return (
    <Box
      id="Howitwork"
      sx={songPage ? homeStyle.howItWorkspopup : homeStyle.howItWorksSection}
    >
      <Box sx={homeStyle.sectionTitle}>
        <Typography variant="h1" sx={homeStyle.sectionTitleH1}>
          {howitworksheading}
        </Typography>
      </Box>
      <Box sx={homeStyle.rowContainer}>
        <Box sx={homeStyle.howItWorksRow}>
          <Box sx={homeStyle.howItWorksRowImage}>
            <Box component="img" src="/images/how-it-works/icon-1.svg" alt="" />
          </Box>
          <Box component="span" sx={homeStyle.Vseparate}></Box>
          <Box sx={homeStyle.hiwRowContent}>
            <Typography component="p" sx={homeStyle.countNum}>
              1
            </Typography>
            <Typography
              variant="h1"
              sx={
                SongDetails
                  ? homeStyle.songDetailhiwRowContentTitle
                  : homeStyle.hiwRowContentTitle
              }
            >
              Invest In Music
            </Typography>
            <Typography
              component="p"
              sx={
                SongDetails
                  ? homeStyle.songDetailHiwRowContentDescription
                  : homeStyle.hiwRowContentDescription
              }
            >
              Mr. Wise invests INR 4000 to buy a Gold NFT for Song A on FanTiger
              & gets a 0.2% royalty income share and exclusive privileges.
            </Typography>
          </Box>
        </Box>
        <Box sx={homeStyle.howItWorksRow}>
          <Box sx={homeStyle.howItWorksRowImage}>
            <Box component="img" src="/images/how-it-works/icon-2.svg" alt="" />
          </Box>
          <Box component="span" sx={homeStyle.Vseparate}></Box>
          <Box sx={homeStyle.hiwRowContent}>
            <Typography component="p" sx={homeStyle.countNum}>
              2
            </Typography>
            <Typography
              variant="h1"
              sx={
                SongDetails
                  ? homeStyle.songDetailhiwRowContentTitle
                  : homeStyle.hiwRowContentTitle
              }
            >
              How does the song make money?
            </Typography>
            <Typography
              component="p"
              sx={
                SongDetails
                  ? homeStyle.songDetailHiwRowContentDescription
                  : homeStyle.hiwRowContentDescription
              }
            >
              Song A is distributed across all streaming platforms (YouTube,
              Spotify, Gaana, Wynk, Saavn, etc). For every stream / view on
              these platforms, the song earns money (royalty income).
            </Typography>
          </Box>
        </Box>
        <Box sx={homeStyle.howItWorksRow}>
          <Box sx={homeStyle.howItWorksRowImage}>
            <Box component="img" src="/images/how-it-works/icon-3.svg" alt="" />
          </Box>
          <Box component="span" sx={homeStyle.Vseparate}></Box>
          <Box sx={homeStyle.hiwRowContent}>
            <Typography component="p" sx={homeStyle.countNum}>
              3
            </Typography>
            <Typography
              variant="h1"
              sx={
                SongDetails
                  ? homeStyle.songDetailhiwRowContentTitle
                  : homeStyle.hiwRowContentTitle
              }
            >
              How do I make money?
            </Typography>
            <Typography
              component="p"
              sx={
                SongDetails
                  ? homeStyle.songDetailHiwRowContentDescription
                  : homeStyle.hiwRowContentDescription
              }
            >
              Let’s say it’s been 1 year and Song A has earned royalty income of
              INR 50 lacs. At 0.2% share, Mr. Wise’s investment would be now
              worth INR 10,000. Hit Songs in the past have given a return as
              high as 2000% - 5000%.
            </Typography>
            <Typography component="small" sx={{ color: "#fff" }}>
              *Disclaimer : music Investment is subject to song performance
              risks, please exercise due caution before investing. Past
              performance is not indicative of future results.
            </Typography>
            {data?.calculator == "true" && (
              <Button
                sx={homeStyle.returnCalculator}
                contained="solid"
                onClick={() => {
                  enquireNowGTMCTAClick(
                    r,
                    "ctaClicks",
                    "loggedIn",
                    "Guest",
                    "Return Calculator"
                  );
                  setCalculator(true);
                }}
              >
                Return Calculator
              </Button>
            )}
          </Box>
        </Box>
        <Box sx={homeStyle.howItWorksRow}>
          <Box sx={homeStyle.howItWorksRowImage}>
            <Box component="img" src="/images/how-it-works/icon-4.svg" alt="" />
          </Box>
          <Box component="span" sx={homeStyle.Vseparate}></Box>
          <Box sx={homeStyle.hiwRowContent}>
            <Typography component="p" sx={homeStyle.countNum}>
              4
            </Typography>
            <Typography
              variant="h1"
              sx={
                SongDetails
                  ? homeStyle.songDetailhiwRowContentTitle
                  : homeStyle.hiwRowContentTitle
              }
            >
              When will I get my money?
            </Typography>
            <Typography
              component="p"
              sx={
                SongDetails
                  ? homeStyle.songDetailHiwRowContentDescription
                  : homeStyle.hiwRowContentDescription
              }
            >
              Song A has a royalty payout period of 5 years.
              <br />
              Mr. Wise has 2 options to get the Money <br />
              <br />
              1. Wait till end of Royalty Period and cash out <br />
              2. Sell on FanTiger Marketplace
            </Typography>
          </Box>
        </Box>
      </Box>
      {calculator && (
        <Popup noCloseButton handlePopupClose={() => setCalculator(false)}>
          <ReturnCalculator
            closePopup={() => setCalculator(false)}
            tierData={tierData}
            version={version}
          ></ReturnCalculator>
        </Popup>
      )}
    </Box>
  );
};
export default HowItWorks;
